import React, { createContext, useContext, useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Navbar from "./components/Navbar";
import AuthModal from "./components/AuthModal";
import HomePage from "./pages/HomePage";
import StudioPage from "./pages/StudioPage";
import AdminPage from "./pages/AdminPage";
import translations from "./translations";
import { AuthProvider } from "./contexts/AuthContext";

export const LanguageContext = createContext();

export function useLanguage() {
  return useContext(LanguageContext);
}

function AppInner() {
  return (
    <>
      <Navbar />
      <AuthModal />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/studio" element={<StudioPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </>
  );
}

function App() {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations["en"]?.[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <AppInner />
          </AuthProvider>
        </BrowserRouter>
        <div style={{
          position: "fixed",
          bottom: 0,
          right: 0,
          width: "220px",
          height: "75px",
          background: "#0D0704",
          zIndex: 2147483647,
          pointerEvents: "none",
        }} />
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
